import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";
import { Link } from "react-router-dom";

function Mapper(data, status, response, error, component) {
	let output = [];
	let property = {};

	property["showTerms"] = "";
	property["showActivationModal"] = "";

	output.push(property);

	return output;
}

function messageForActivation(_this) {
	let UserType = Functions["custom"]["getUserType"]();
	let landPageData = JSON.parse(sessionStorage.landPageData);

	if (landPageData.contractInfoCarrier.hasInternet) {
		if (UserType === "POSTB") {
			return (
				<>
					<h2>
						Mε την υπηρεσία αυτόματης ενημέρωσης <br /> έχετε τον απόλυτο έλεγχο
						του Μοbile Internet!
					</h2>
					<h4>
						Μπορείτε να ενεργοποιήσετε την υπηρεσία My Internet μέσω του
						υπευθύνου συνδέσεων της Εταιρίας σας. <br />
						<br />
						Για περισσότερες πληροφορίες μπορείτε να επικοινωνήσετε με την
						Εξυπηρέτηση Εταιρικών Πελατών-13818. <br />
					</h4>
				</>
			);
		} else if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
			return (
				<>
					<h2>
						Η υπηρεσία <b>My Internet</b> ήρθε
						<br /> και σου δίνει τον Απόλυτο Έλεγχο στη χρήση <b>Internet!</b>
					</h2>
					<h3>Γιατί τώρα έχεις</h3>
					<h4>
						Αυτόματη ενημέρωση και διακοπή της πλοήγησης όταν σου τελειώνουν τα
						ΜΒ, με ταυτόχρονη προώθηση χωρίς χρέωση στην σελίδα του{" "}
						<b>My Internet</b> για να ενεργοποιήσεις το πακέτο ΜΒ που σου
						ταιριάζει, και να συνεχίσεις το σερφάρισμα
					</h4>

					<h6>
						Μπορείτε να ενεργοποιήσετε την υπηρεσία My Internet μέσω του
						υπευθύνου συνδέσεων της Εταιρίας σας. <br />
						<br />
						Για περισσότερες πληροφορίες μπορείτε να επικοινωνήσετε με την
						Εξυπηρέτηση Εταιρικών Πελατών-13818.
					</h6>
				</>
			);
		} else if (UserType === "HYBRID_RESIDENTIAL_COST_CONTROL") {
			return (
				<>
					<h2>
						Η υπηρεσία <b>My Internet</b> ήρθε
						<br /> και σου δίνει τον Απόλυτο Έλεγχο στη χρήση <b>Internet!</b>
					</h2>
					<h3>Γιατί τώρα έχεις</h3>
					<h4>
						Αυτόματη ενημέρωση και διακοπή της πλοήγησης όταν σου τελειώνουν τα
						ΜΒ, με ταυτόχρονη προώθηση χωρίς χρέωση στην σελίδα του{" "}
						<b>My Internet</b> για να ενεργοποιήσεις το πακέτο ΜΒ που σου
						ταιριάζει, και να συνεχίσεις το σερφάρισμα
					</h4>
					<a
						style={{ cursor: "pointer" }}
						onClick={(e) => clickMeActivate(_this)}
						className="submit open-lightbox customClassActivationPopUpButton">
						Ενεργοποίηση
					</a>
				</>
			);
		} else if (UserType === "POSTR" || UserType === "POSTB_SPLIT") {
			return (
				<>
					<h2>
						Mε την υπηρεσία αυτόματης ενημέρωσης <br /> έχετε τον απόλυτο έλεγχο
						του Μοbile Internet!
					</h2>
					<h3>Γιατί πλέον έχετε</h3>
					<h4>
						Άμεση ενημέρωση μόλις ξεπεράσετε το 80% <br />
						<br /> Απόλυτο έλεγχο του τι πληρώνετε για πλοήγηση στο Internet{" "}
						<br /> καθώς η πλοήγηση θα διακόπεται αυτόματα όταν καταναλώσετε{" "}
						<br /> το 100% των διαθέσιμων ΜΒ <br />
						<br /> Δυνατότητα να επιλέξετε εσείς πως θα συνεχίστε να σερφάρετε{" "}
						<br /> στο Internet.
					</h4>
					<a
						style={{ cursor: "pointer" }}
						onClick={(e) => clickMeActivate(_this)}
						className="submit open-lightbox customClassActivationPopUpButton">
						Ενεργοποίηση
					</a>
				</>
			);
		} else {
			if (landPageData.contractInfoCarrier.inListOfWhatuspCss) {
				return (
					<>
						<h2>
							Η υπηρεσία <b>My Internet</b> ήρθε
							<br /> και σου δίνει τον Απόλυτο Έλεγχο στη χρήση <b>Internet!</b>
						</h2>
						<h3>Γιατί τώρα έχεις</h3>
						<h4>
							Αυτόματη ενημέρωση και διακοπή της πλοήγησης όταν σου τελειώνουν
							τα ΜΒ, με ταυτόχρονη προώθηση χωρίς χρέωση στην σελίδα του{" "}
							<b>My Internet</b> για να ενεργοποιήσεις το πακέτο ΜΒ που σου
							ταιριάζει, και να συνεχίσεις το σερφάρισμα
						</h4>
						<a
							style={{ cursor: "pointer" }}
							onClick={(e) => clickMeActivate(_this)}
							className="submit open-lightbox customClassActivationPopUpButton">
							Ενεργοποίηση
						</a>
					</>
				);
			} else {
				return (
					<>
						<h2>
							Η υπηρεσία <b>My Internet</b> ήρθε
							<br /> και σου δίνει τον Απόλυτο Έλεγχο στη χρήση <b>Internet!</b>
						</h2>
						<h3></h3>
						<h4>
							Η νέα υπηρεσία My Internet σε ειδοποιεί κάθε φορά που τελειώνουν
							τα ΜΒ σου και κόβει αυτόματα το σερφάρισμά σου για να μη
							χρεώνεσαι. Για να συνεχίσεις, απλά ενεργοποιείς από τη σελίδα του
							My Internet το πακέτο που θέλεις και ξεκινάς πάλι το
							σερφάρισμα!{" "}
						</h4>
						<Link
							style={{ cursor: "pointer" }}
							onClick={(e) => clickMeActivate(_this)}
							className="submit open-lightbox customClassActivationPopUpButton">
							Ενεργοποίηση
						</Link>
					</>
				);
			}
		}
	} else {
		window["modal"].setState({
			show: true,
			footer: [],
			body: (
				<>
					<div className="icon-activation"></div>
					<div className="thank-hold errorPageDisplay">
						<div
							className="thank"
							style={{ display: "block" }}>
							<h2 className="errorheader">
								Σας ενημερώνουμε ότι η υπηρεσία <br /> αυτή τη στιγμή δεν είναι
								διαθέσιμη.
							</h2>{" "}
							<h2 className="errorheader2">
								Για περισσότερες πληροφορίες καλέστε <br />
								την Εξυπηρέτηση Πελατών- 13888
							</h2>{" "}
							<a
								href="/"
								className="cancel">
								Επιστροφή &gt;
							</a>
						</div>
					</div>
				</>
			),
		});
	}
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		id: {
			alias: "id",
			type: "text",
			label: "ID",
			editable: editable,
		},
		showActivationModal: {
			alias: "showActivationModal",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				let landPageData = JSON.parse(sessionStorage.landPageData);

				return (
					<div className="hold">
						{landPageData.contractInfoCarrier.hasInternet ? (
							<div className="icon-activation"></div>
						) : null}
						{messageForActivation(_this)}
					</div>
				);
			},
		},
	};
}

function clickMeActivate(_this) {
	let manager = _this.props.manager;
	let data = _this.props.data;
	window["modal"].setState({
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		// footer: [],
		body: (
			<Manager
				key="modalForActivation"
				module="modalForActivation"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

const ActivationPage = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: [{}],
					replace: {},
					mapper: Mapper,
				},
			},
			template: "activatePage",
			templateConfiguration: {
				includeProperties: [],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default ActivationPage;
